import axios from 'axios';
import { getAuthHeader } from './authApi';

export interface User {
  id: number;
  first_name: string;
  last_name: string;
  username: string;
  is_admin: boolean;
  last_login?: string;
}

export interface UserFormData {
  first_name: string;
  last_name: string;
  username: string;
  password?: string;
  is_admin: boolean;
}

export interface FormEntry {
  p: number; // points earned for this match
  t: number; // 0=nothing, 1=winner only, 2=exact score
}

export interface UserPoints {
  id: number;
  first_name: string;
  last_name: string;
  form?: FormEntry[];
  score_success_count: number;
  winner_success_count: number;
  points: number;
}

// Fetch all users
export const getUsers = async (): Promise<User[]> => {
  try {
    const response = await axios.get('/api/users', {
      headers: getAuthHeader()
    });
    return response.data || [];
  } catch (error) {
    console.error('Error fetching users:', error);
    return [];
  }
};

// Fetch a single user by ID
export const getUser = async (id: number): Promise<User | null> => {
  try {
    const response = await axios.get(`/api/users/${id}`, {
      headers: getAuthHeader()
    });
    return response.data;
  } catch (error) {
    console.error(`Error fetching user ${id}:`, error);
    throw error;
  }
};

// Create a new user
export const createUser = async (userData: UserFormData): Promise<User> => {
  try {
    const response = await axios.post('/api/users', userData, {
      headers: getAuthHeader()
    });
    return response.data;
  } catch (error) {
    console.error('Error creating user:', error);
    throw error;
  }
};

// Update an existing user
export const updateUser = async (id: number, userData: UserFormData): Promise<User> => {
  try {
    const response = await axios.put(`/api/users/${id}`, userData, {
      headers: getAuthHeader()
    });
    return response.data;
  } catch (error) {
    console.error(`Error updating user ${id}:`, error);
    throw error;
  }
};

// Delete a user
export const deleteUser = async (id: number): Promise<void> => {
  try {
    await axios.delete(`/api/users/${id}`, {
      headers: getAuthHeader()
    });
  } catch (error) {
    console.error(`Error deleting user ${id}:`, error);
    throw error;
  }
};

// Fetch user points
export const getUserPoints = async (): Promise<UserPoints[]> => {
  try {
    const response = await axios.get('/api/users/points', {
      headers: getAuthHeader()
    });
    return response.data || [];
  } catch (error) {
    console.error('Error fetching user points:', error);
    return [];
  }
}; 